import template from './time_management_setup_help.html';
import * as Utils from '../../lib/savanna_utils.js';

class ApprovalStructureHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class ApprovalStructureHelpPage
{
	constructor (bindings) {
		this.viewModel = new ApprovalStructureHelpViewModel(this);
		this.bindings = bindings;
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default {
	name: 'ApprovalStructureHelp',
	dialog_class: ApprovalStructureHelpPage,
	template: template,
	template_filename: 'translation/dialogs/time_management_setup',
	provider: 'ps'
};
